import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  imei: string().max(100, 'Max length - 100 symbols'),
});

export default yupResolver(validationSchema);
